import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
interface ProductCardProps {
  title: string;
  description: string;
  image: string;
  link: string;
  index: number;
}
export function ProductCard({
  title,
  description,
  image,
  link,
  index
}: ProductCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 border border-beige flex flex-col h-full" data-id="element-49">
      <div className="relative aspect-[4/5] overflow-hidden" data-id="element-50">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-51" />
        <div className="absolute inset-0 bg-black/5 group-hover:bg-transparent transition-colors duration-500" data-id="element-52" />
      </div>

      <div className="p-8 flex flex-col flex-grow space-y-4" data-id="element-53">
        <h3 className="text-2xl md:text-3xl font-semibold text-text-dark leading-tight" data-id="element-54">
          {title}
        </h3>
        <p className="text-text-muted text-lg leading-relaxed flex-grow" data-id="element-55">
          {description}
        </p>
        <div className="pt-4" data-id="element-56">
          <motion.a href={link} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="relative inline-flex items-center justify-center gap-2 px-8 py-3 bg-gradient-to-r from-[#4A3B6B] via-[#6B5A8E] to-[#4A3B6B] bg-[length:200%_auto] text-white rounded-full font-medium text-lg overflow-hidden group/btn transition-all duration-500 hover:bg-right hover:shadow-[0_0_20px_rgba(74,59,107,0.3)]" data-id="element-57">
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/btn:animate-[shimmer_1.5s_infinite]" style={{
            skewX: '-20deg'
          }} data-id="element-58" />
            <SparklesIcon className="w-4 h-4 text-gold opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300" data-id="element-59" />
            Ver programa
            <ArrowRightIcon className="w-5 h-5 transition-transform group-hover/btn:translate-x-1" data-id="element-60" />
          </motion.a>
        </div>
      </div>
    </motion.div>;
}